<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga w-100">
                <div class="h3Organization w-50">
                    <img src="../../../assets/images/title-icon.png" alt="">
                    <h3>Roles</h3>
                </div>
                <div class="right-header-container">
                    <div class="twoInputs">
                        <div class="btnInsideInput w-100">
                            <button @click="getRoles" ref="buttonSearch" class="search-btn">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                placeholder="Search" autocomplete="off"
                                @input="searchHandler" maxlength="50">
                        </div>
                    </div>
                    <div class="fullInputs mb-4">
                    <div class="oneInput w-100">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="getRoles">
                            <option selected disabled value="false">Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>

                    
                    <router-link class="text-decoration-none btn-container" v-if="permissions.includes('create role') && roles.length > 0"
                                to="/create-role">
                        <span>Create</span>
                    </router-link>
                </div>
            </div>

            <div class="tabcontent">

                
                <div class="table-container" v-if="roles.length > 0">

                    <TableComponent :thead="thead" :tbody="roles" @sort="SortRole" :keys="keys"
                                    model="roles" name="role"
                                    updateUrl="/edit-roles" @update="updateRole"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getRoles" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="no-data-header-container">
                        <h3 class="no-data-header" v-if="!isSearch">You Don't Have Any Roles Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container  btn-container-no-data"
                                 v-if="permissions.includes('create role') && roles.length === 0 && !isSearch"
                                 to="/create-role">
                        <span>Create Role</span>
                    </router-link>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import roles from "../../../api-services/roles";

    export default {
        name:'plateform_permissions-index',
        data(){
            return{
                role:'',
                thead: ['Role Name' , 'Members'],
                keys: ['name' , 'users_count'],
                roles: [],
                filteredArray: [],
                permissions:[],
                originalRoles: [],
                laravelData: {},
                error: null,
                search: '',
                sort: false,
                state: false
            }
        },
        mounted(){
            this.role = this.$store.state.auth.user.data.role[0];
            this.permissions = this.$store.state.auth.permissions;
            this.getRoles();
            this.$store.dispatch('activeTap', 'roles');
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        methods:{
            getRoles: async function (page = 1) {
                try {
                    const response = await roles.index(this.search, this.sort === false ? this.sort = 'desc' : this.sort, page);
                    console.log(response);
                    this.roles = response.data.data;
                    this.laravelData = response.data;
                    this.originalRoles = response.data.data;

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }
            },
            updateRole(e) {
                let filteredData = this.roles.filter(function (data) {
                    return data.id != e;
                });
                this.roles = filteredData;
            },
            searchHandler(e) {
                this.isSearch = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                //
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
                // searchedData = this.originalRoles.filter((data) =>  data.name.toLowerCase().indexOf(serachedValue) >= 0);
                // this.roles = searchedData;
            },
            async searchBackEndHandler(searchFlag = false) {
                let dataLength = this.roles.length;
                if (searchFlag && dataLength > 0) {
                    await this.getRoles(searchFlag);
                }
            },
            SortRole() {
                let status = !this.state;
                this.originalRoles.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    .no-data-header{
        font-size: 18px;
    }
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
    .create-btn-text{
        font-size: 17px;
    }
    .tabcontent{
        height:73vh;
        padding-top: 0 !important;
        overflow-y: auto;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }
    .h3Organization img{
        margin-bottom:0;
        padding-right: 10px;
    }
    .h3Organization h3{
        text-transform: uppercase;
        font-weight: 600;
        margin-bottom: 0;
        font-size: calc(1.1rem+0.6vw);
    }
    .right-header-container{
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        width:45%;
        height: 35px;
    }
    .right-header-container .btn-container{
        font-size: 16px;
        width: 25%;
        font-weight: normal;
    }
    .twoInputs{
        width:45%;
    }
    .search-btn{
        width: 10%;
        border-radius: 6px 0 0 6px;
        background-color:#707070;
        align-items: center;
        padding-bottom: 3px;
    }
    .btnInsideInput{
        border-radius: 6px;
        background-color: #707070;
    }
    .btnInsideInput input{
        border-radius: 6px;
        background-color: #707070;
        padding-left: 0;
        padding-top: 5px;
        padding-bottom: 0;
        
    }
    .form-control {
        color: white !important;
        display: flex;
        justify-content: left;
        width:90% !important;
        padding-left: 10px !important;
    }
    .designRowOrga{
        padding-left:40px !important;
        padding-right: 40px;
        height: 50px;
        align-items: center;
        margin-bottom: 2%;
    }
    .paginationLink{
        font-size:11px;
        font-weight: bold;
        width:99%;
    }
    .fullInputs{
        width:25%;
        height: 100%;
    }
    .oneInput{
        height: 100%;
    }
    #filter_dates{
        width:100% !important;
        border: none;
        padding:0;
        padding-left: 10px;
        height: 100% !important;
    }
    #free_search::placeholder{
        opacity: 1 !important;
        color: white !important;
        /* font-size: 19px; */
    }
    @media(max-width:1280px){
        .h3Organization{
            width: 40% !important;
        }
        .h3Organization img{
            width: 5vh !important;
        }
        .right-header-container{
            width:60%;
            /* margin-top: 10px; */
        }
        .twoInputs{
            margin-bottom:0 !important;
        }
        .table-container :deep(thead :first-child){
        width:70% !important;
        }
        .table-container :deep(thead :nth-child(2)){
        width:15% !important;
        }
        .tabcontent{
            padding-top: 0 !important;
            overflow-y: scroll;
        }
    }
    @media(max-height:767px){
        .tabcontent{
            height: 69vh;
        }
    }
</style>